module.exports = __webpack_public_path__ + "static/media/pepsico.2312bd16.png";